// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"5312804f","496":"3cf92bc6","669":"be02eaf9","996":"c4b1a5b7"}[chunkId] + ".chunk.js";
};